import React, { useEffect } from 'react'
import CloseIcon from '@mui/icons-material/Close';
import { Typography } from '@mui/material';

const Popup = ({children , isOpen, onClose , image , text}) => {

    useEffect(() => {
        if (isOpen) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = 'auto';
        }
    
        return () => {
          document.body.style.overflow = 'auto';
        };
      }, [isOpen]);
    
      if (!isOpen) return null;
  return (
    <div className='fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center'>
        <div className='bg-white rounded-md px-4 py-14 relative'>
            <button onClick={onClose} className='absolute top-2 right-2'>
                <CloseIcon sx={{color:'black'}}/>
            </button>
            <div className='flex flex-col gap-4 items-center'>
                <img src={image} alt="" className='w-28'/>
                <Typography variant='h6' sx={{fontWeight:600}}>{text}</Typography>
                
                {children}
            </div>
        </div>
    </div>
  )
}

export default Popup